import axios from '@/utils/request'

const fetchRemittanceList = (exporterId, limit, page) => {
  return axios({
    method: 'GET',
    url: `/v1/business/exporters/${exporterId}/view/remittance_list?limit=2&page=1`,
    params: {
      limit,
      page
    }
  })
}

const fetchRemittanceDetails = (remittanceId) => {
  return axios({
    method: 'GET',
    url: `/v1/business/remittances/${remittanceId}`
  })
}
const removeRemittance = (exporterId, remittanceId) => {
  return axios({
    method: 'DELETE',
    url: `/v1/business/exporters/${exporterId}/remittances/${remittanceId}`
  })
}

const fetchBuyerList = (exporterId) => {
  return axios({
    method: 'GET',
    url: `/v1/business/exporters/${exporterId}?include[]=clients_locked`
  })
}

const fetchBankList = (exporterId, currency, status) => {
  return axios({
    method: 'GET',
    url: `/v1/business/exporters/${exporterId}/call/bank_list`,
    params: {
      'vars[currency][]': currency,
      'vars[status][]': status
    }
  })
}

const fetchInvoiceByImporterId = (exporterId, currency, importerId) => {
  return axios({
    method: 'GET',
    url: `/v1/business/exporters/${exporterId}/call/invoices_list`,
    params: {
      'vars[additional_filters][status]': 'open',
      'vars[additional_filters][currency]': currency,
      'vars[additional_filters][importer_user_id]': importerId,
      serializer: 'Business::MinimalInvoiceSerializer'
    }
  })
}

const addRemittance = (data) => {
  return axios({
    method: 'POST',
    url: `/v1/business/remittances`,
    data
  })
}

export const removeDocument = (exporterId, docId) => {
  return axios({
    method: 'DELETE',
    url: `v1/onboarding/leads/${exporterId}/documents/${docId}`
  })
}

export default {
  fetchRemittanceList,
  addRemittance,
  fetchRemittanceDetails,
  removeRemittance,
  fetchInvoiceByImporterId,
  fetchBankList,
  fetchBuyerList,
  removeDocument
}
